import { Avatar, SectionHeader, Text } from '@pentabd/ui';

const Comments = () => {
  return (
    <div>
      <SectionHeader title="Comments" />
      <div className="py-9 row g-6">
        <span className="col-xl-1">
          <Avatar imageURL="https://i.pravatar.cc/300" size="sm" />
        </span>
        <div className="col-xl-11">
          <div className="d-flex justify-content-between mb-2">
            <Text color="title" weight="medium" size="sm">
              Katherine Moss
            </Text>
            <Text size="xs" color="subtitle1">
              Today 2:20pm
            </Text>
          </div>
          <Text size="md" color="dark" className="p-4 comments">
            Hey Olivia, can you please review the latest design when you can?
          </Text>
        </div>
      </div>
    </div>
  );
};
export default Comments;
